import React, { PropsWithChildren } from 'react';
import { Colors } from './Colors';


import './Square.scss';

type Props = {
    color: Colors;
};

const Square: React.FC<PropsWithChildren<Props>> = ({color, children}) => {
    
    return (
        <div className={`ar-1-1 bg-${color}`}>
            {children}
        </div> 
    );
};

export default Square;